import GenericOption from './GenericOption'

export { GenericOption }
